// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__16gMY","error":"Button_error__1aeLc","success":"Button_success__3qssF","primary":"Button_primary__3YoEr"};